import React, { useContext } from 'react'
import { Spinner, View } from 'oio-react'
import NotFound from 'src/pages/NotFound'
import { useMe } from 'src/graphql/hooks'
import ThemeContext from 'src/libraries/contexts/Theme'
import Inbox from '~/Messages/apps/Inbox'

const Messages = () => {
   const theme = useContext(ThemeContext)
   const { isLoggedIn, networkStatus } = useMe()
   const initialLoading = networkStatus <= 2

   // TODO: This should probably go to some kind of Unauthorized component instead
   if (!initialLoading && !isLoggedIn) {
      return <NotFound />
   }

   return (
      <View
         position="absolute"
         top={theme.viewportMarginTop}
         left={theme.viewportMarginLeft}
         right={theme.viewportMarginRight}
         bottom="0px"
         padding="20px[c-f]"
         backgroundColor="#f5f5f5"
         scroll="on">
         <View
            display="flex"
            justifyContent="center">
            <View
               width="100%"
               maxWidth="700px"
               backgroundColor="#fff"
               borderRadius="5px"
               padding="20px[a] 30px 9vw[b] 60px 80px[c-f]">
               {initialLoading && (
                  <View
                     position="absolute"
                     top="0px"
                     left="0px"
                     right="0px"
                     bottom="0px"
                     display="flex"
                     justifyContent="center"
                     alignItems="center">
                     <Spinner color="#ccc" width="48px" height="48px" />
                  </View>
               )}
               {!initialLoading && (
                  <Inbox />
               )}
            </View>
         </View>
      </View>
   )
}

export default Messages
